/* eslint-disable */
import app from "new-ui/app";
import { EDIT_QUESTION_POPUP_ACTION_SOURCE } from 'utils/constants/actionSource';
import './EditQuestion.css';
import Intake from "new-ui/Components/Intake";
import { waitFor } from "new-ui/functions";
import React, { useEffect, useRef } from "react";
import { render } from "react-dom";

const EditQuestion = ({ question }) => {
    const $ = useRef();

    useEffect(()=>{
        const fetch = async ()=>{
            const customQuestions = [question];
            waitFor(()=>{
                return app.user
            }, ()=>{
                render(
                    <Intake
                        id="editQuestionPopup"
                        className="single-question-intake"
                        user={app.user}
                        flatMode
                        expand="all"
                        customQuestions={customQuestions}
                        onUpdate={() => {
                          app.handleUserUpdate({ actionSource: EDIT_QUESTION_POPUP_ACTION_SOURCE });
                        }}
                        gotoResultsAction={()=>{
                            app.setPopup(false);
                        }}
                    />,
                    $.current,
                )
            }, ()=>{

            })
        }
        fetch();
    }, []);
    return <div ref={$} className="edit-question-popup"></div>
};

export default EditQuestion;
